import FormInput from './FormInput.vue';

export default FormInput;
